<template>
    <div class="navbar-unlogged__actions">
        <AuthLink
            class="joy-link navbar-unlogged__actions-link"
            role="signin"
            component-source="navbar-unlogged"
            :redirect="redirectUrl"
            data-testid="navbar-signin-link"
        >
            <span :data-text="$t(`navbar.cta.${selectedMode}.signin` as keyof AllTranslationsRecord)">
                {{ $t(`navbar.cta.${selectedMode}.signin` as keyof AllTranslationsRecord) }}
            </span>
        </AuthLink>
        <NavbarSignupCta />

        <div v-if="!hasMultipleModes" class="navbar-unlogged__actions-locale-selector">
            <LocaleSelection />
        </div>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {AuthLink} from '#components';
    import {useRequestURL} from '#imports';
    import NavbarSignupCta from './NavbarSignupCta.vue';
    import {useNavbarMode} from '../composables/useNavbarMode';
    import LocaleSelection from '../features/localization-selection/ui/LocaleSelection.vue';
    import type {AllTranslationsRecord} from '#build/i18n';

    const {hasMultipleModes, selectedMode} = useNavbarMode();
    const url = useRequestURL();
    const redirectUrl = computed(() => url.pathname + url.search);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    /* mobile-first */
    .navbar-unlogged__actions {
        display: flex;
        align-items: center;
        flex-direction: column-reverse;
        gap: var(--joy-core-spacing-6);
        padding: var(--joy-core-spacing-4) var(--joy-core-spacing-4) var(--joy-core-spacing-8) var(--joy-core-spacing-4);
        width: 100%;

        &-locale-selector {
            display: none;
        }

        &-link.joy-link {
            @include text.getFontBySize(primary-400);
            font-weight: var(--joy-font-weight-bold);
            // color: var(--joy-color-neutral-50);
            // text-decoration: none;
            // cursor: pointer;
            text-decoration: underline;
            text-underline-offset: 6px;
        }

        &-cta {
            width: 100%;
            .joy-button {
                width: 100%;
                --padding-x: var(--joy-core-spacing-7);
                padding-left: var(--padding-x);
                padding-right: var(--padding-x);
            }
        }
    }

    /* desktop */
    @include mq.screen_sm(min) {
        .navbar-unlogged__actions {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: var(--joy-core-spacing-4);
            margin-left: auto;
            margin-top: 0;
            height: 100%;
            width: auto;
            padding: 0;

            &-cta {
                width: auto;
            }

            &-locale-selector {
                display: block;
            }
        }
    }
</style>
